import type { EntityAdapter } from '@ngrx/entity';
import type { Action } from '@ngrx/store';
import type {
  CompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import type { CourierOutput } from 'core/http/project';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  initialCompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import * as CouriersActions from './couriers.actions';

export interface CouriersState extends CompletedEntityState<CourierOutput> {}

const adapter: EntityAdapter<CourierOutput> = createEntityAdapter<CourierOutput>();

export const initialCouriersState: CouriersState = adapter.getInitialState(initialCompletedEntityState);

const reducer = createReducer(
  initialCouriersState,
  on(CouriersActions.saveCouriers, (state, payload) => adapter.setAll(payload.couriers, state)),
  on(CouriersActions.markCouriersLoaded, state => ({ ...state, loaded: true })),
  on(CouriersActions.setLoading, (state, { value }) => ({ ...state, loading: value })),
  on(CouriersActions.setError, (state, { value }) => ({ ...state, error: value })),
);

export function couriersReducer(state: CouriersState | undefined, action: Action): CouriersState {
  return reducer(state, action);
}

export const {
  selectAll,
  selectEntities,
  selectTotal,
} = adapter.getSelectors();
